import templateUrl from './mismatch-hla-field.html';

function frmMismatchHlaField() {
  return {
    restrict: 'A',
    scope: {
      model: '=',
      required: '&'
    },
    templateUrl: templateUrl
  };
}

export default frmMismatchHlaField;



/** WEBPACK FOOTER **
 ** ./src/app/forms/fields/mismatch-hla-field.directive.js
 **/